import ClowncarAppConstants from 'constants/ClowncarAppConstants';

export function fetchScheduleHistoryList(businessId: number): ApiAction {
  return {
    TockApi: {
      getListProto: `/internal/reportdata/${businessId}/inventoryschedule/history`,
      type: ClowncarAppConstants.SCHEDULE_HISTORY_FETCH_LIST,
    },
  };
}

export function fetchScheduleHistoryDetail(historyId: number): ApiAction {
  return {
    TockApi: {
      getProto: `/internal/reportdata/inventoryschedule/history/${historyId}`,
      type: ClowncarAppConstants.SCHEDULE_HISTORY_FETCH_DETAIL,
    },
  };
}
